export class PayloadTooLargeError extends Error {
  constructor() {
    super('O arquivo enviado é muito grande. Tente enviar um arquivo menor.')
    this.name = 'PayloadTooLargeError'
  }
}
